import React, { useEffect, useRef, useState } from "react";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../../assets/DataView/DataViewDemo.css";
import "../../assets/DataView/index.css";
import { InputText } from "primereact/inputtext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "jspdf-autotable";
import { FilterMatchMode } from 'primereact/api';
import { errorMessage } from "../../utils/alertMessage";
import { formatDateWithTime } from "../../constants/FormateDate";
import { getLeadType, getUserLead, getUserLeadStatus } from "../../services/leads";
import { Dropdown } from "primereact/dropdown";
import { getUserData } from "../../utils/localStorage";
import { replaceUnderscoresWithSpacesAndUpperCase } from "../../components/Regex";
import { Calendar } from "primereact/calendar";
import { DataScroller } from "primereact/datascroller";
import { Button } from "primereact/button";

export default function OperationLeadList() {

  const navigate = useNavigate();

  const { userProfileData } = getUserData();

  const ds = useRef(null);

  const location = useLocation();
  const isFirstRender = useRef(true);

  const [products, setProducts] = useState(null);
  const [filteredProducts, setFilteredProducts] = useState(null);

  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(20);
  const [loadingMore, setLoadingMore] = useState(false);


  const [startDateValue, setStartDateValue] = useState(null);
  const [endDateValue, setEndDateValue] = useState(null);


  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    id: { value: null, matchMode: FilterMatchMode.CONTAINS },
    name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    mobile: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    quires: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    address: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  });

  const [globalFilterValue, setGlobalFilterValue] = useState('');

  const searchByStatusData = [
    { label: "Name", value: "name" },
    { label: "Mobile", value: "mobile" },
    { label: "Quires", value: "quires" },
    { label: "Address", value: "address" },
  ]

  const recordTypeSelection = [
    { label: "CreatedOn", value: "CreatedOn" },
    { label: "LeadOn", value: "LeadOn" },
    { label: "FollowUpOn", value: "FollowUpOn" },
    { label: "ClosedOn", value: "ClosedOn" }]

  const [recordTypeValue, setRecordTypeValue] = useState("CreatedOn")
  const [leadTypeList, setLeadTypeList] = useState([])
  const [typeOfLead, setTypeOfLead] = useState('')



  const [searchByStatus, setSearchByStatus] = useState('name');

  const typeData = {
    searchBy: "",
    searchText: "",
    limit: 20,
    offset: 0,
    sortBy: "",
    sortOrder: "desc",
    statusIn: [],
    sourceIn: [],
    userIdIn: [userProfileData.id],

    recordType: recordTypeValue,
    startDate: "",
    endDate: "",
    leadTypeIn: [] ,
    userLeadStatusIn: ["ASSIGN", "WORKING", "ASSIGN_TO_OTHER"]
  };

  const fetchData = (data, append = false) => {
    setLoadingMore(true);

    getUserLead(data)
      .then((response) => {
        if (!response.data.error) {

          const rawData = response.data.data || response.data;

          // 🔥 Extract only the lead object
          // const newData = rawData.map(item => item.lead);

          if (append) {
            setProducts((prev) => [...(prev || []), ...rawData]);
          } else {
            setProducts(rawData);
          }

          setTotalRecords(response.data.totalRecords || rawData.length);
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch(() => {
        errorMessage();
      })
      .finally(() => {
        setLoadingMore(false);
      });
  };

  const [userLeadStatus, setUserLeadStatus] = useState([])
  const [selectedUserLeadStatus, setSelectedUserLeadStatus] = useState("");

  const fetchUserLeadStatus = () => {

    getUserLeadStatus()
      .then((response) => {
        if (!response.data.error) {

          const rawData = response.data.data || response.data;
          const newDataIds = rawData.map(item => ({
            label: item, value: item
          }));
          setUserLeadStatus(newDataIds)
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch(() => {
        errorMessage();
      })
  };

  useEffect(() => {

    getLeadType()
      .then((response) => {
        if (!response.data.error) {
          const leadStatus = response.data.map((item) => ({
            label: item,
            value: item,
          }));
          setLeadTypeList(leadStatus);
        }
      })
      .catch(() => errorMessage());

    fetchUserLeadStatus()
    if (location.state?.listState) {
      const { products, first, rows } = location.state.listState;

      setProducts(products);
      setFirst(first);
      setRows(rows);
    } else {
      fetchData({
        ...typeData,
        limit: rows,
        offset: 0
      });
    }
  }, []);

  useEffect(() => {

    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    let startDate = "";
    let endDate = "";

    if (startDateValue) {
      startDate = new Date(startDateValue);
      endDate = endDateValue ? new Date(endDateValue) : new Date();
    }

    // Check if any filter exists
    const hasValidFilter =
      selectedUserLeadStatus ||
      recordTypeValue ||
      typeOfLead ||
      startDateValue ||
      endDateValue;

    if (!hasValidFilter) return;

    // if (selectedUserLeadStatus !== "") {

    fetchData({
      ...typeData,
      limit: rows,
      offset: 0,
      userLeadStatusIn: selectedUserLeadStatus ? [selectedUserLeadStatus] : ["ASSIGN", "WORKING", "ASSIGN_TO_OTHER"],
      recordType: recordTypeValue,
      startDate,
      endDate,
      leadTypeIn: typeOfLead?  [typeOfLead] : []
    });
    // }
  }, [selectedUserLeadStatus, recordTypeValue, typeOfLead, startDateValue, endDateValue]);

  const loadMore = () => {
    const newOffset = first + rows;

    fetchData(
      {
        ...typeData,
        limit: rows,
        offset: newOffset
      },
      true // append mode
    );

    setFirst(newOffset);
  };

  const onFilter = (event) => {
    setFilters(event.filters);

    let searchBy = "";
    let searchText = "";

    // Detect which column filter is applied
    Object.keys(event.filters).forEach((key) => {
      if (key !== "global" && event.filters[key]?.value) {
        searchBy = key;
        searchText = event.filters[key].value;
      }
    });

    fetchData({
      searchBy,
      searchText,
      limit: 20,
      offset: 0,
      sortBy: "",
      sortOrder: "desc",
      statusIn: [],
      sourceIn: [],
      userIdIn: [userProfileData.id]
    });
  };

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;

    setGlobalFilterValue(value);
    setFirst(0);
    setProducts([]);

    fetchData({
      searchBy: searchByStatus,
      searchText: value,
      limit: 20,
      offset: 0,
      sortBy: "",
      sortOrder: "desc",
      statusIn: [],
      userIdIn: [userProfileData.id]
    });
  };

  const itemTemplate = (data) => {
    return (
      <div>
      </div>
    )
  }


  return (
    <main id="main" className="main">
      <section className="section main-color">
        <div className="row">
          <div className="col-lg-12">
            <div className="card-main">
              <div className="card-body">
                <h5 className="card-title flex">
                  <div
                    className="mr-3 cursor-pointer"
                    onClick={() => navigate("/")}
                  >
                    <i class="bi bi-arrow-left-circle-fill"></i>
                  </div> Lead List
                </h5>
                <p className="text-md" style={{ color: "red" }}> * Note: Please User Filters To Find Or Sort Leads Based On Your Requirement</p>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginTop: 5,
                    marginBottom: 5,
                  }}
                >
                  <div className="row">
                    <div className="col-md mb-2">
                      <InputText
                        type="text"
                        value={globalFilterValue}
                        onChange={onGlobalFilterChange}
                        placeholder="Keyword Search"
                        style={{ width: "100%" }}
                      />
                    </div>
                    <div className="col-md mb-2">
                      <Dropdown
                        style={{ width: "100%" }}
                        options={searchByStatusData}
                        value={searchByStatus}
                        onChange={(e) => {
                          setSearchByStatus(e.value);
                        }}
                      />
                    </div>
                    <div className="col-md mb-2">
                      <Dropdown
                        style={{ width: "100%" }}
                        options={userLeadStatus}
                        value={selectedUserLeadStatus}
                        placeholder="Select Status"
                        onChange={(e) => {
                          setSelectedUserLeadStatus(e.value);
                        }}
                      />
                    </div>
                    <div className="col-md mb-2">
                      <Dropdown
                        style={{ width: "100%" }}
                        options={recordTypeSelection}
                        value={recordTypeValue}
                        placeholder="Select Record Type"
                        onChange={(e) => {
                          setRecordTypeValue(e.value);
                        }}
                      />
                    </div>
                    <div className="col-md mb-2">
                      <Dropdown
                        style={{ width: "100%" }}
                        options={leadTypeList}
                        value={typeOfLead}
                        placeholder="Select Lead Type"
                        onChange={(e) => {
                          setTypeOfLead(e.value);
                        }}
                      />
                    </div>
                    <div className="col-md mb-2">
                      <Calendar
                        value={startDateValue}
                        onChange={(e) => {
                          const start = e.value;
                          setStartDateValue(start);

                          if (!endDateValue) {
                            setEndDateValue(new Date()); // default today
                          }
                        }}
                        dateFormat="dd/mm/yy"
                        placeholder="Start Date"
                        maxDate={endDateValue ? endDateValue : new Date()}
                        showIcon
                        style={{ width: "100%" }}
                      />
                    </div>
                    <div className="col-md mb-2">
                      <Calendar
                        value={endDateValue}
                        onChange={(e) => setEndDateValue(e.value)}
                        dateFormat="dd/mm/yy"
                        placeholder="End Date"
                        minDate={startDateValue}
                        showIcon
                        style={{ width: "100%" }} />
                    </div>




                  </div>
                  <div className="row">
                    <div className="col-md">

                      <Link
                        to="/lead-form-operation-team-create"
                        className="move-btn move-btn-blue center-text"
                      >
                        Create
                      </Link>
                    </div>
                  </div>


                </div>
                <div className="dataview-demo">
                  <div className="card">
                    <DataTable
                      value={products}
                      // lazy
                      dataKey="id"
                      scrollable
                      scrollHeight="400px"
                      first={first}   // ✅ THIS FIXES YOUR ISSUE
                      onPage={(e) => setFirst(e.first)} // ✅ also required
                      paginator
                      paginatorTemplate=" FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                      currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                      rows={rows}
                      rowsPerPageOptions={[rows, rows + 50, rows + 100]}
                      loading={loadingMore}
                      className="p-datatable-customers client-table-design"
                      resizableColumns
                      columnResizeMode="fit"
                      filters={filters}
                      onFilter={onFilter}
                      // filterDisplay="row"
                      globalFilterFields={['id', 'createdDate', 'name', "mobile", "city", "state"]}
                      stripedRows
                    >
                      <Column
                        header="#"
                        resizeable={false}
                        className="product-category table-design"
                        body={(data, options) => options.rowIndex + 1}
                      ></Column>
                      <Column
                        field="View"
                        header="View"
                        className="product-category table-design"
                        body={(rowData) => (
                          <Link
                            to="/lead-form-operation-team-create"
                            state={{
                              rowData,
                              listState: {
                                products,
                                first,
                                rows
                              }
                            }}
                            className="move-btn-medium move-btn-yellow center-text"
                          >
                            View <i className="bi bi-pencil-square"></i>
                          </Link>
                        )}
                      ></Column>
                      <Column
                        field="loanFile"
                        header="Loan File"
                        className="product-category table-design"
                        body={(rowData) => (
                          <Link
                            to={"/view-loan-file"}
                            state={rowData?.lead}
                            className="move-btn-medium move-btn-green center-text"
                          >
                            Loan File <i className="bi bi-eye"></i>
                          </Link>
                        )}
                      ></Column>
                      <Column
                        field="typeOfLead"
                        header="Type Of Lead"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData?.lead?.typeOfLead ? replaceUnderscoresWithSpacesAndUpperCase(rowData?.lead?.typeOfLead) : ""}

                          </span>
                        )}
                      ></Column>
                      <Column
                        field="status"
                        header="Status"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {(rowData?.status)}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="name"
                        header="Name"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData?.lead?.name}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="mobileNo"
                        header="Mobile No"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.lead?.mobileNo}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="address"
                        header="Address"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.lead?.address}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="amount"
                        header="Amount (In Lacs)"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.lead?.amount}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="queries"
                        header="Queries"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.lead?.queries}
                          </span>
                        )}
                      ></Column>
                      <Column
                        field="source"
                        header="Source"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.lead?.source}
                          </span>
                        )}
                      ></Column>

                      <Column
                        field="followUpOn"
                        header="Follow Up On"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {rowData.lead?.followUpOn}
                          </span>
                        )}
                      ></Column>

                      <Column
                        field="dateOfLead"
                        header="Date Of Lead"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {formatDateWithTime(rowData.lead?.dateOfLead)}
                          </span>
                        )}
                      ></Column>


                      <Column
                        field="status"
                        header="Status"
                        className="product-category table-design"
                        body={(rowData) => (
                          <span>
                            {(rowData.lead?.status)}
                          </span>
                        )}
                      ></Column>

                      
                      <Column
                        field="Doc"
                        header="Doc View"
                        className="product-category table-design"
                        body={(rowData) => (
                          <Link
                            to={"/view-lead-document"}
                            state={rowData?.lead}
                            className="move-btn-medium move-btn-green center-text"
                          >
                            Doc View <i className="bi bi-eye"></i>
                          </Link>
                        )}
                      ></Column>

                    </DataTable>
                  </div>
                  <DataScroller
                    ref={ds} 
                    value={products} 
                    itemTemplate={itemTemplate} 
                    rows={5} 
                    loader 
                    // footer={footer} 
                    // header="Click Load Button at Footer to Load More" 
                  />
                  <div
                    className="flex justify-content-center fixed "
                    style={{ bottom: 30, left: 20 }}
                  >
                    <Button
                      type="text"
                      icon="pi pi-plus"
                      // label="More"
                      onClick={loadMore} // Update this to trigger `getData`
                    />
                  </div>
                  {/*products && products.length < totalRecords && (
                    <div style={{ textAlign: "center", margin: "20px" }}>
                      <button
                        onClick={loadMore}
                        disabled={loadingMore}
                        style={{
                          padding: "10px 20px",
                          backgroundColor: "#1e439b",
                          color: "#fff",
                          border: "none",
                          cursor: "pointer",
                          borderRadius: "5px"
                        }}
                      >
                        {loadingMore ? "Loading..." : "Load More"}
                      </button>
                    </div>
                  )*/}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
